import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
import ThemeContext from './ThemeContext';

export default function withTheme(Component) {
	const componentName = Component.displayName || Component.name || 'Component';
	const withThemeRender = (props, ref) => (
		<ThemeContext.Consumer>
			{(theme) => <Component ref={ref} {...props} theme={theme} />}
		</ThemeContext.Consumer>
	);
	// $FlowFixMe
	const WithTheme = React.forwardRef(withThemeRender);

	WithTheme.displayName = `WithTheme(${componentName})`;

	return hoistNonReactStatics(WithTheme, Component);
}
